import {
  BooleanInput,
  DateInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "@/components/admin"
import { required } from "ra-core"
export default function EditOverview() {
  return (
    <div className="bg-secondary rounded-md grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-6 xs:grid-cols-6 gap-4 p-6">
      <TextInput label="Titre" source="title" validate={required()} />
      <NumberInput
        label="Surface (m²)"
        source="surface"
        validate={required()}
      />

      <NumberInput
        label="Nombre d'étages"
        source="floors"
        validate={required()}
      />
      <NumberInput
        label="Nombre de chambres"
        source="bedrooms"
        validate={required()}
      />
      <NumberInput label="Budget min." source="budget.min" />

      <NumberInput label="Budget max." source="budget.max" />
      <DateInput label="Date de début" source="dates.start" />
      <DateInput label="Date d'achèvement" source="dates.end" />
      <ReferenceInput reference="project_types" source="type">
        <SelectInput />
      </ReferenceInput>
      <ReferenceInput reference="project_styles" source="architectural_style">
        <SelectInput />
      </ReferenceInput>
      <ReferenceInput reference="cities" source="city">
        <SelectInput />
      </ReferenceInput>
      <TextInput label="Région" source="region" />

      <BooleanInput source="has_garden" label="Je veux un jardin" />
      <BooleanInput source="has_pool" label="Je veux une piscine" />
      <BooleanInput source="has_terrace" label="Je veux une terrasse" />
      <BooleanInput source="has_basement" label="Je veux un sous-sol" />
    </div>
  )
}
